import UserLoad from './user-load';

export default UserLoad;
